import React, { useState, useEffect } from 'react';
import * as firebase from 'firebase';
import logo from './logo.svg';
import Calendar from 'react-calendar';
import { Link } from 'react-router-dom';
import { differenceInCalendarDays } from 'date-fns';
import AwesomeSlider from 'react-awesome-slider';
import DatePicker from 'react-datepicker';
import firebaseinit from './firebase-credentials';
import moment from 'moment';
import {Helmet} from "react-helmet";
import Slider from 'rc-slider';
import Modal from 'tg-modal';
import ReactModal from 'react-modal';
import {useSpring, animated, useTransition} from 'react-spring';
import NumericInput from 'react-numeric-input';
import { addDays, addMonths, subDays, eachDay } from "date-fns";

import './App.css';
import 'react-calendar/dist/Calendar.css';
import 'rc-slider/assets/index.css';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-awesome-slider/dist/custom-animations/open-animation.css';
import 'react-awesome-slider/dist/styles.css';

const disabledDates = [new Date(), new Date(2020, 9, 1, 0, 0, 0), new Date(2020, 9, 2, 0, 0, 0),new Date(2020, 9, 3, 0, 0, 0), new Date(2020, 9, 4, 0, 0, 0), new Date(2020, 9, 5, 0, 0, 0), new Date(2020, 9, 6, 0, 0, 0), new Date(2020, 9, 7, 0, 0, 0), new Date(2020, 9, 8, 0, 0, 0), new Date(2020, 9, 9, 0, 0, 0), new Date(2020, 9, 10, 0, 0, 0), new Date(2020, 9, 11, 0, 0, 0), new Date(2020, 9, 12, 0, 0, 0), new Date(2020, 9, 13, 0, 0, 0), new Date(2020, 9, 14, 0, 0, 0), new Date(2020, 9, 15, 0, 0, 0), new Date(2020, 9, 16, 0, 0, 0), new Date(2020, 9, 17, 0, 0, 0), new Date(2020, 9, 18, 0, 0, 0), new Date(2020, 9, 19, 0, 0, 0), new Date(2020, 9, 20, 0, 0, 0), new Date(2020, 9, 21, 0, 0, 0), new Date(2020, 9, 22, 0, 0, 0), new Date(2020, 9, 23, 0, 0, 0), new Date(2020, 9, 24, 0, 0, 0), new Date(2020, 9, 25, 0, 0, 0), new Date(2020, 9, 26, 0, 0, 0), new Date(2020, 9, 27, 0, 0, 0), new Date(2020, 9, 28, 0, 0, 0), new Date(2020, 9, 29, 0, 0, 0), new Date(2020, 9, 31, 0, 0, 0)];
const database = firebaseinit.database();


const tileData = [
    {
      img: 'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAkGBxASEhURExIWFRUXGRgWFhYWFRUVGBgXFhkaFxsVFRYYICsgGBolIBYYIjIhJykrLi4uFx8zODMtNygtLisBCgoKBQUFDgUFDisZExkrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrK//AABEIAG8BxwMBIgACEQEDEQH/xAAcAAEAAwADAQEAAAAAAAAAAAAABQYHAQQIAwL/xABLEAABAwIDBQMIBgYIBAcAAAABAAIDBBEFEiEGBxMxQVFhcQgUIjKBkaGxFSMzQmJzNDVScrLBFiRDU2N0grNUk8LwJSZEktHT4f/EABQBAQAAAAAAAAAAAAAAAAAAAAD/xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwDcEREBERAREQEREBERAREQEREBERAREQEREBERAREQEREBERAREQEREBERAREQEREBERAREQEREBERAREQEREBERAREQEREBERARFwg5RcIg5RcLlAREQEREBERARcEog5RcJdByi4ul0HKIiAiIgIiICIiAiIgIiICIiAiIgIiICIiAiIgIuCl0HKLhLoOUREBERAREQEREBERAREQEREFU3nYpNTYdPNA8skblDXaE3LgNL+KreymA45PEyaqxJ8OYXEcbY72PIvLmnXwVx2ywo1VNwbXvJC4juZI1/8lNtbYWtyCDDd52NYnhUkTIq+WQSNJPEbFcEdlmjRd7dlU4lisUssuIzRGN4YBG2Gxu3Nc5mnt+CjfKR+2pf3H/MKY8m/9Eqfzh/A1BI7X4HjdPC+elxKSXIMzo5Gx5so5lpa3nbornsRXyT0NPNI7M97GlzuVye1drHMSihZaQOs+7fRY51rjrbkqrgG2eE01OIjVsGQkFrrtcNb5S0jRBfUUNSbRwSxvlbnysFz6Dhcdw5lRzt4OGAlr6lsbhrlkBY63gRdBakVag23oXjMxz3tPJzY3uB7wQNV8JN42FNJa6paxw5tddpHiDyQWxFAP2tpQM31hBFweE+1u29uS61Ht/hcsjYWVTDI45Qw6G/Zr1QWdyrWKbO1MjnOjxGeK/JrWxFrfC7SferKLIUHmfaDb3GaSplpfPC7hPLMxYy57zotV2Nwutq6OGplxKoD5W5yGCENF9bAZOiwreW22KVf5pXpTdx+rKT8pnyCCOr9kcROsOL1DT2PZC4X9jLrN8S2g2gosQhpampu1722cGtyvYTbS4uPBapjGKyNxOhpmv8ARkE7pGDqGxnKT2AGyhN8WHNfHST/AHoqmEA9z5GjX3oNEauV+Ba3v+ardRtvSCZ0EZfPI312wMdIG8/Wc3kdOSCzoq+za6k4csjnGPgjNIyRpY9rf2srtSO9TNLO2RgkbycA4eBFwg+6Kt122VGyY07XOmlHrMha6Qs/MLPU9vgucK2xpJpjTF7o5hrwpmmJ5Ha0OtmHggsaKFxraalpD9e4sHMuyuyDxcNAuMC2ooqwkU07JC3UgHUA9bIJtFHYxjMNM0PlLg09Q1zgO8kclDUm8DDZXBkVRxXH7rA5xt2mw5ILUih8a2jpaVrXTSAF3qMGsjiejYx6Tj7FFv27pIy3jtmga/1XyxPYzwLjo068igtiLpz4lE2LjXzMtcFgz5gerct7quu3k4SLg1bWkaEEEEEcwRbQoLci69HVMlY2WNwcx4DmuBBBHaD1C6WPbQ0tE1r6mVsQcbNLjzPd2oJVFV6fb3DpL8KYy258NjnW8bDRKnb3D47cWUxX5cRrmX8LjVBaEVZpNucPlNopDJqBdjHOAJ7SBopLG8epqSMSTyhgPqg+s49jW8ye5BKLgqsxba09g58c8bDa0kkL2NF9AXEizRr17VJ02NQSVD6ZjryMY2R1tRlf6uqCgbwcUxU4nT0VDNk4kZc64BDbc3u7lN0uyWIht5cXqC7rkZCG/Fl1L0+DkYjJVlv9iyNh9typ8BB5ixXeLjEM8sArHERyPjDiyO5DHFtzpz0WxYbs7WzQRy/S1SC9jXH0YdCRc2BZqF522q/WFV/mJf8AcK9a4A3+rQj/AA2fwhBmpdjVDidHDNWOnpZpMpdka2/ok5H2Gh06W5LW1TNqsdohJGJnOj4EzHl7o3BmgPJ9rW1Xag2/w15tHPxDzIY1ziPEAaILSirFVt5h0VuLKYr8uIx7AfC41XdwHaeirMwpp2ylnrZSdL9fBBNIvnNK1jS5xADQST2AC5PuCqzN4uFONmVTXuJsGtu4k/hA5oLaig5NpYGxiXLMWkkaRSE+j1LQLgKLZvJwouyecemTbJlOa/Zlte/cguCKtVG2tHGC54maBzLoZBbxuNF+sC20w+sk4VPOHvtmsNDYczqgsaKCxXaenhl4HpSzWDjHE0yOaDyLg31Qe9MP2nglkELg+GR18rZmFme2voF3rHuCCdRdLCsTiqGudE7MGvdGT+JmhHvRB3UKIUGDeUl9rS/uv+YUx5OH6JU/nD+BqhfKRd9fSj8DvmFNeTh+iVP5w/gag197AeYB+K8z7XQg7RZcosaiIWtobuHTkvTRXmXbPif0idwy0P48YYXC7Q7S2YDmL2QelRG3kGgdunRYD5RkYFVTWAF4nchb73W3Nab5vtD/AH9D/wAiX/7FkO+9lcJqfzx8D3cN2Qwscyzc2ocHON9UG8bHwtFFTWDR9SzkANcoWAb3mAY24ADXg3HQnReg9kP0Gm/JZ/CF593xA/TbrGx+pse/TVB6FxWsbT0r5soIjZfLpawsLKjbbYLE92H4lHE1j2zQ57AC7ZCBY27CvjvPocW8yc7jxugbkMsccRa8tuLkvJ5dTor8xsHmkbpAOG1jH3PIZQCCglR/371yvnBK1zQ5puCAQe0HVfRB5J3o/rWs/MPyC2rY/EsVjw6mEFAyVojaGuM7W5hYWcQeV1im883xWrP+IfkvSO7gf+GUn5TPkEGZbF4pW1G0QNYzhyNila2PowW5NPUd62jEcPinaGSsD23a6x5Xabg+whVHGqJrMcoJxoXxzxu7wGFwJ79FZtpa3g0k817ZI3uB7wDZBn2/Dax9LTNpICWyT3BcDYtjGpt2X5K17ucCZSUMLGtGZzRJI7q5z/SJJOp529iwPeFUyS/Rskri5z6WN7nHqXOufgvTODW4EVuWRtvcEFL3yYAyow+aYACSFvEBGl2tN3Nd2i19FD7zNsnUWHU8MN2yzxNsR91gaAT8bLTsSpY5YnxSC7HNLXeB5rzrv1laaqn4ZvEKdoj8A4g/JBru6bBG0+HxPt9bMOLI46ucX66u5qM34YMH0XnbPQlp3B4eNHZdQW39t/YrjseR5lTW/uY+X7oUdvQAOF1V/wC7KCD3YbTjE8PfHUAPkiBjkuAc4to7xKyavpqnBKqCugdeGW72GxDS0n0oX9/8rKw+TsXcWq524Yv2XK0iHZ+DEMKZTyDRzSWO6scHGxCCd2axyCvpmVEWrXgZmkAlriNWu7wdPYqjhQpcNZilXkFmTOIGUcuG2zG9gzLNNjsaqcBxF1JU34DnZXgiwtybMz4e9W3eQ4nDa8sNw6qYbg3BaWtN7+CD4bm2vxGsqMSqjne30WA6hmaxs0chawC1rHMLjqYJIJWhzXtI1A0NjYjvCzPycyPNqgDnxBf3LXXIMH3ObUyU9Y/Cp3FzC97I765XxkjL4EBdze1s/E9lZLHGGvh4MhsBqH3Dj8FS3gt2jIZz89NrdmY3W41FE2err4HD0XwRtPtzIIfcXjPHw5sRPpQOyf6bXHwUZvdcJoKxx1bTNiay40zyuIf7QLe9VTcliBpMRno5DlBbICHaWdFc637grRtxGfoGomdo6eUTOH7zgA32BoQffyeYx5hLoL8U627u1fryhom+YRuyi4lbY2F9QdE8nj9Al/NPyX78of8AVzPzW/IoPpuYljiwfjOAAa6VzjYcmkm9+uirO72qdjOMS1k9nRwC8TDctFyQ0gcr2Xa2ScRstVFpN8s3zXU8m316vwZ8yg3CaFrmlrmgtIsQbEW7LLONgsFFJjGIRNvkdHFIy5JIa9zvRBPQWOi0sqKMdPHV5+U8zC3n6zIzf4XQSy4QIg8dbUfrCp/zMv8AuFet8B/RoPy2fILyRtR+sKn/ADMv+4V63wH9Gg/LZ8gghN58bfoqtNh9i7oFm/k3xNJrHWF/qh/GtK3n/qmt/Jcs48mz/wBb4xf9aDRtvaSF8LDIwODZWWuB1NreGqyDd/IcMx+SkOjXudF3a+mwrZdujamJ/Gw+5wWPb8aM0uI09cy4L2tdcftxkfyKDZtr6giFsLfWneIW/wCq9/gCsO2HgjbtE5jAA1r5QBb9kW/+VsFDVtraqmlbrGynE/dnmALPaAHe9ZBsMf8AzG/8yb5oPRZjHKw9y83SQt/pMW2FvOOQGnJelF5qrGvO0zhG4Ndx9C4XA07EG87S4sKdkZyB3ElbEAbWJebdeaqrMFjpceZLCwNE9LK5zQLDOwt5dl7qN23ocRbW0EtROySn85jGSOMsyuJ0Lud1pNa+Bkkb35Q8nhxk87u1LR42+CDNN0m0dMZKxkz2tq3VD3OLzYubchrQ488oFrLRsbwuKrhdG7qPRe0+k09HNcORWU7Y7rY62SSrw6ZocZHCSMmzRI02dld903VJnptosLOa9QxreoJkZbv7kGz7naN8NA6B/rRzzMJP3rP9b2ourul29+ko3xyta2dmrstgHg/eA6HtRBoa/JeO1fpQ+L7O09S4Pkz3At6MkjBbwa4AoMX8oyQGppgCLhjrjsuVO+TnI0UtSLi/GGlxe2Qaq3S7rcIeS58Dnk9XzTOPszO0XMG6/CWG7IHMP4J52e8NfqguRcvNG1z7bR300qIj2jm1bu/Y+mycMOla2+b7aQnXvJuod+6fB3HMYXlxN8xnmLr9ubPdBdw7v9qwDyjXg1dMP8F38S2TDdlaeCOSJjpMsmhzSvcR4FxJHsUNU7rcKlOeWN8juWZ80p07Bd2iCd2PkBoaY3H2LOv4QvP+99w+nCbj+x/ktrg3eULGCNhmDByAnl08LuXUl3T4Q8lz4XvcebnTTF3vzILTiVE2op3wudpIzKSOw9QqNvZx+Gkw00jZAZZGtia0HUDQFxHTkp1u7+jAyh04A0A84m5DpfNddGbdNhDzmdE9zu1085PvL7oLZgrctPCB0jjHuaF23zNHMgdtzZfmCFrGtY3k0ADnyAsPFVnFd39BUSOllEpc7U2nnaP/AGteAPcg83bwpWvxKqc03BkNjzHwXpHdlUtdhlL6TdI2g2PLQaaqPbujwX/hifGWU/Ny7Ee6/CW6NhkaOxtTUNHuD7BBaqjggiR5YC29nEjQHnYlZDvp3gQGB1BTPEjnj6xzT6LW35X6kq5SbrsLd6zZneNTUH/rXwO6DBbW83P/ADpfnmQZ1tlszJUYNh9ZC0udBA1jwNTkPUdtitY3bY9HWUEL2kZ2NEcjb3LXMABB9lj7VOYVhcNPC2nibaNjcrWkl1m9hLrk+1V6o3e0fGNRA6Smkd6xgeWhx7SwnLfwCCT2pxptNC770r/QijGrnvdoAAOnUnos73o7ByS0EEkbS6anaQ5o5ua45nAdtiVoeE7L08EnGu+SW1uJK9zyB+EE5W8+gCmy0IKHubx1lRh8cd7SwDhvaTqCNAbdF+N9GMNjoHUzTeaoIjYwauN+dgPBS9dsNSvm85iMlNMeb4H5M37zfVPM9F9sI2KpIJjUuzTTnTizOLyB2NafRb7AEFb3X7MjCqB8tSWskkHEkuRZjQNGk/MKc3a4vDUUMbmOGhcC0HlZ7hyXc2h2QpK1zXVDXuDRYNEsrGkfia1wB9oXRoN2+GQPEkMToyDezZpw0kdrM+U+5BHb2diBiFOZI2jziMXYf2m9WFVbddg/nuC1VHJcOMjm3dza4AEc+w/NbOBoozB8DhpnTOiBbxpOK8XNi8gC4HTQDlogx/ctUPw+tnw2pHDe/Vt9A5zLCzT1uLkeC2bFsRZBC+aRwa1jSSTp0XR2l2VpK5oE8fpNN2yNJY9p7WvaQVGO2BgfkFRNUVDGEFrJJXZdOVwwjMP3roM43TbMy1VfJi8zS2LiPfFmFs7nk2cL9ACtGw/FIfpaphzgv4ERtca6u0v29ysNdhUcsPA1YzQAMJZYDoMtrexVyLdjhLXcQQOz3vn48+Ynvdnv05ckGW7fbNuGPwiMuaKt7XZm9/rkey60LfMxrcHlaCNOGOzkRyVs/o9S54ZTHd9O0sicXPJaHDKeZ9LTqbro4hsPh89xLEXgnMQ6WYi/blzW+CCmeTy7+oy/mns7OxfvyhZB9Hxi+plb8AVaKfd5hkf2UTor88k0rQfEB1l+andzhcluLE6W3LPNM4C/YC6yCt7naVk+Cup3EWeZWO5aZr9FVN2GbB8WmoqkZBMMrHnRrsriWlt+d7rUKTd3hsTs0UT47EGzJpg0kfhD7fBSm0OzNHWsDKiIOt6rrlr2kci17SCLeKCWc8WvcW7eiq2G1ArK907NYqZhjbIOTpHkZw3tAA5jtX5p9hIQ0ROqamSIaCN0zgLdmZtnfFWejpI4mNjjYGMaLBrRYD2IPtdfN8gAJv8AEe1ft7bghVqq2GopM2cSnNcn+sTjn4P0QeXdpJAa2ocDcGeUg9v1hsV602bnDqWAgj7NnUH7o71XBunwX/hQfGSQn2kuXapN3WGxfZslb3CpqLewF9kH03nyD6KrL/3LuuvRZx5N7wDWDr9Uf41o+JbCUNQSZhI8G12maUN05XDXAFdWHdlhcZzRRPiPUxzStv4gOsg7W8eujhonyPcAA5lr9SXj/wDT7FXt9OFNqsL4zCCYS2VpGvoEWKm8Q3d0E9uPxZQOTXTSZfaA6x9q7+H7HUcEb4WMdwpG5HMdJJILdgL3Ej2WQVvclROjw1kjzd0hc4X6MB0A7lm2w1v6Rv1/tJvmVuDtlaXhRQgPbHE3IxrXvaMvKxINz7bqJZuwwlrs7YCH3vmE0odftuHXKC4515vkkA2mLri3nH8luE2x1M+JsLnzFrS5wImka70uYLmkG3tUUzdTg4N+A7Ne+YzTZr9odmuPegseOYY2pYxpdlyPbICLaFpVK2wx+KbFcOoo3hxZMZpC03sQwtDTb94lWCfYOhcMp4tuwVEw+IddfHCt2+F00zamKEiVhu1xlkebnqczjf2oK1sJj3Br8Qge0iB1S/hyn7NsjtTGT0J+ei0+TKW2Ni0jW+oI776KPgwCmbFJDw2lkjnPe09XPNydet/d0UUdimZDD51UiA6cLiXGX9niH07f6kFN3YYO1uK4jUwAebhxijI9Uuvdwb2gG6LUcIw2GmibDCwMjYLBo+Z7T3nVEHcREQEREBERAREQEREBERAREQEREBERAREQEREBERAREQEsiICIiAlkRAREQEREBLIiAiIgIiICIiAiIgJZEQEREBERAREQEREBERAREQEREBERAREQEREBERAREQEREBERAREQEREBERAREQEREBERAREQEREBERAREQEREBERAREQEREBERAREQEREBERAREQEREH/9k=',
      link: 'https://economictimes.indiatimes.com/small-biz/startups/can-peer-to-peer-delivery-service-take-off-in-india/articleshow/66393685.cms',
    },
    {
      img: 'https://firebasestorage.googleapis.com/v0/b/beckfriends-2-a4131.appspot.com/o/Logo-BBC.jpg?alt=media&token=8718a0a3-01de-489c-a15f-0ec54c8b099d',
      link: 'http://www.bbc.com/news/business-39851770',
    },
    {
      img: 'https://firebasestorage.googleapis.com/v0/b/beckfriends-2-a4131.appspot.com/o/hindu.png?alt=media&token=61a2c6ec-da27-4113-a876-fa8e5604f664',
      link: 'https://www.thehindu.com/news/cities/mumbai/delivery-on-wings/article22361445.ece',
    },
    {
      img: 'https://firebasestorage.googleapis.com/v0/b/beckfriends-2-a4131.appspot.com/o/publications%2Fentrepreneur.jpg?alt=media&token=3031ae54-2fdc-446f-b76c-f4ef3b13cde2',
      link: 'https://www.entrepreneur.com/article/275577?utm_source=Social&utm_medium=Sharebar&utm_campaign=Sumome_share',
    },
    {
      img: 'https://firebasestorage.googleapis.com/v0/b/beckfriends-2-a4131.appspot.com/o/publications%2Ftimesofindia.png?alt=media&token=b2255d64-4435-4165-bdf4-8deb399d4a5e',
      link: 'http://www.gadgetsnow.com/tech-news/BECK-Technology-Ventures-launches-peer-to-peer-marketplace/articleshow/51702666.cms',
    },
    {
      img: 'https://firebasestorage.googleapis.com/v0/b/beckfriends-2-a4131.appspot.com/o/publications%2Fiamwire.jpg?alt=media&token=92cda725-6580-4e97-903c-ef436b161338',
      link: 'http://www.iamwire.com/2016/04/beck-friends-peer-peer-delivery-service/134616',
    },
    {
      img: 'https://firebasestorage.googleapis.com/v0/b/beckfriends-2-a4131.appspot.com/o/publications%2Fvccircle.jpg?alt=media&token=3c94a63d-408d-4086-831c-4aad39659803',
      link: 'https://www.techcircle.in/2016/04/21/how-beck-friends-p2p-logistics-service-works-and-why-it-isnt-an-easy-business/',
    },
    {
      img: 'https://i.insider.com/597a0306b50ab126008b4b46?width=1100&format=jpeg&auto=webp',
      link: 'https://www.businessinsider.in/this-startup-helps-you-earn-while-you-travel-have-cash-on-your-beck-now/articleshow/53449557.cms',
    },
    {
      img: 'data:image/png;base64,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',
      link: 'https://www.firstpost.com/business/beck-technology-ventures-launch-beck-friends-to-disrupt-global-logistics-space-2713596.html',
    },
    {
      img: 'https://www.loksatta.com/wp-content/themes/vip/loksatta/images/logo.png',
      link: 'https://www.loksatta.com/mumbai-news/mumbai-youth-started-new-business-1270759/',
    },
    {
      img: 'https://firebasestorage.googleapis.com/v0/b/beckfriends-2-a4131.appspot.com/o/publications%2Fzeebiz.jpg?alt=media&token=2b26938b-71c7-40b7-b9f9-69bdaf396e5c',
      link: 'http://www.zeebiz.com/small-business/interview-start-up-delivery-services-finds-a-way-for-you-to-earn-back-your-air-ticket-fare-2486',
    },
    
  ]

function isSameDay(a, b) {
  return differenceInCalendarDays(a, b) === 0;
}

function tileDisabled({ date, view }) {
  // Disable tiles in month view only
  if (view === 'month') {
    // Check if a date React-Calendar wants to check is on the list of disabled dates
    return disabledDates.find(dDate => isSameDay(dDate, date));
  }
}

function App() {
  const props = useSpring({opacity: 1, from: {opacity: 0}});
  const [on, toggle] = useState(false);
   const [value, setValue] = useState(new Date());
   const [showbookingdate, setshowbookingdate] = useState(false);
   const [showdeliverydate, setshowdeliverydate] = useState(false);
   const [weight, setweight] = useState('0');
   const [bookingdate, setbookingdate] = useState(new Date());
   const [deliverydate, setdeliverydate] = useState(new Date());
   const [bookingbutton, setbookingbutton] = useState('Booking Date');
   const [deliverybutton, setdeliverybutton] = useState('Delivery Date');
   const [shipping, setshipping] = useState('0');
   const [isOpen, setOpen] = useState(false);
    const [ack, setack] = useState(false);

   const [startDate, setStartDate] = useState('');

   const [bname, setbname] = useState('');
   const [person, setperson] = useState('');
   const [bemail, setemail] = useState('');
   const [bnum, setnum] = useState('');

   const [imageLoad, setLoad] = useState(false);

   const [width, setWidth] = useState(0)
  const [device, setdevice] = useState('desktop')
  const [parentdevice, setparentdevice] = useState('')
  const [newdevice, setnewdevice] = useState('newdesktop')

  const [mobile, setmobile] = useState(true)

   useEffect(() => {
   
   setWidth(window.innerWidth)
   if(window.innerWidth <= 768) 
    {
      setdevice('mobile')
      setnewdevice('newmobile')
      setparentdevice('parentdevice')
    }
    else
    {
setmobile(false)
    }
   
  },[])

   const highlightWithRanges = [
    {
      "react-datepicker__day--highlighted-custom-1": [
        new Date(2020, 10, 1),
        new Date(2020, 10, 2),
        new Date(2020, 10, 3),
        new Date(2020, 10, 4),
        new Date(2020, 10, 5),
        new Date(2020, 10, 6),
        new Date(2020, 10, 7),
        new Date(2020, 10, 8),
        new Date(2020, 10, 9),
        new Date(2020, 10, 10),
        new Date(2020, 10, 11),
        new Date(2020, 10, 12),
        new Date(2020, 10, 13),
        new Date(2020, 10, 14),
        new Date(2020, 10, 15),
        new Date(2020, 10, 16),
        new Date(2020, 10, 17),
        new Date(2020, 10, 18),
        new Date(2020, 10, 19),
        new Date(2020, 10, 20),
        new Date(2020, 10, 21),
        new Date(2020, 10, 22),
        new Date(2020, 10, 23),
        new Date(2020, 10, 24),
        new Date(2020, 10, 25),
        new Date(2020, 10, 26),
      ]
    },
    {
      "react-datepicker__day--highlighted-custom-2": [
       new Date(2020, 10, 27),
       new Date(2020, 10, 28),
       new Date(2020, 10, 29),
       new Date(2020, 10, 30),
       new Date(2020, 11, 1),
       new Date(2020, 11, 2),
       new Date(2020, 11, 3),
       new Date(2020, 11, 4),
       new Date(2020, 11, 5),
       new Date(2020, 11, 6),
       new Date(2020, 11, 7),
       new Date(2020, 11, 8),
       new Date(2020, 11, 9),
       new Date(2020, 11, 10),
       new Date(2020, 11, 11),
       new Date(2020, 11, 12),
       new Date(2020, 11, 13),
       new Date(2020, 11, 14),
       new Date(2020, 11, 15),
      ]
    },
    {
      "react-datepicker__day--highlighted-custom-3": [
       new Date(2020, 11, 16),
       new Date(2020, 11, 17),
       new Date(2020, 11, 18),
       new Date(2020, 11, 19),
       new Date(2020, 11, 20),
       new Date(2020, 11, 21),
       new Date(2020, 11, 22),
       new Date(2020, 11, 23),
       new Date(2020, 11, 24),
       new Date(2020, 11, 25),
       new Date(2020, 11, 26),
       new Date(2020, 11, 27),
       new Date(2020, 11, 28),
       new Date(2020, 11, 29),
       new Date(2020, 11, 30),
       new Date(2020, 11, 31),
      ]
    },
    {
      "react-datepicker__day--highlighted-custom-4": [
       new Date(2021, 0, 1),
       new Date(2021, 0, 2),
       new Date(2021, 0, 3),
       new Date(2021, 0, 4),
       new Date(2021, 0, 5),
       new Date(2021, 0, 6),
       new Date(2021, 0, 7),
       new Date(2021, 0, 8),
       new Date(2021, 0, 9),
       new Date(2021, 0, 10),
       new Date(2021, 0, 11),
       new Date(2021, 0, 12),
       new Date(2021, 0, 13),
       new Date(2021, 0, 14),
       new Date(2021, 0, 15),
       new Date(2021, 0, 16),
       new Date(2021, 0, 17),
       new Date(2021, 0, 18),
       new Date(2021, 0, 19),
       new Date(2021, 0, 20),
       new Date(2021, 0, 21),
       new Date(2021, 0, 22),
       new Date(2021, 0, 23),
       new Date(2021, 0, 24),
       new Date(2021, 0, 25),
       new Date(2021, 0, 26),
       new Date(2021, 0, 27),
       new Date(2021, 0, 28),
       new Date(2021, 0, 29),
       new Date(2021, 0, 30),
       new Date(2021, 0, 31),
      ]
    },
  ];

   const [route, setRoute] = useState('NA');

   const [showfees, setshowfees] = useState(false);

   const [fee, setfee] = useState('----');

   function onChangebdate(nextValue) {
    console.log(nextValue);
    setbookingdate(nextValue);    
    let date = nextValue.getDate() + '/' + nextValue.getMonth() + '/' +nextValue.getFullYear();
    setbookingbutton(date);
    showbdate();
    calculate(nextValue);
  }

  function calculate(nextValue) {
    let bdate = nextValue.getDate();
    let shippingchgs = '400/kg';
    console.log(weight);
    let difference = 23 - nextValue.getDate();
    if( difference > 10 )
    {
      console.log('no surge');

    }
    if(( difference > 4 ) && ( difference <= 10 ))
  {
    console.log('surge');
    shippingchgs = '445/kg';
  }
  if(( difference <= 4 ))
  {
    console.log('Max Surge');
    shippingchgs = '460/kg';
  }
  setshipping(shippingchgs);

  }

  function onChangeddate(nextValue) {
    setdeliverydate(nextValue);
    let date = nextValue.getDate() + '/' + nextValue.getMonth() + '/' +nextValue.getFullYear();
    setdeliverybutton(date);
    showddate();
  }

  function showbdate() {
    setshowbookingdate(!showbookingdate);
  }

  function showddate() {
    setshowdeliverydate(!showdeliverydate);
  }

  function changeRouteBoth() {
    setRoute('BOTH');
    calculateRateRoute('BOTH');
  }

  function changeRouteDomestic() {
    setRoute('DOMESTIC');
    calculateRateRoute('DOMESTIC');
  }



  function changeRouteInternational() {
    setRoute('INTERNATIONAL');
    calculateRateRoute('INTERNATIONAL');
  } 

  function changeDate(date) {
    setStartDate(date);
    calculateRateDate(date);
  }

  function changeWeight(weight) {
    setweight(weight);
    calculateRateWeight(weight);
  }

  function calculateRateDate(date) {
    const month = moment(date).format('MMM');
    const day = moment(date).format('D');
    let rate = 0;
    let routeval = route;
    const weightval = weight;
    if (weightval === 0) {
      routeval = 'NA';
    }
    if (routeval === 'BOTH') {
      if (month === 'Nov') {
        console.log(routeval);
        console.log(month);
        console.log(weightval);
        if ((day >= 1) && (day <= 26)) {
          rate = 360;
        }
        if (day > 26) {
          rate = 440;
        }
      }
      if (month === 'Dec') {
        if ((day >= 1) && (day <= 15)) {
          rate = 440;
        }
        if ((day > 15) && (day <= 31)) {
          rate = 460;
        }
      }
      if (month === 'Jan') {
        rate = 376;
      }
      if (month === 'Feb') {
        rate = 376;
      }
    }
    if (routeval === 'DOMESTIC') {
      if (month === 'Nov') {
        console.log(routeval);
        console.log(month);
        console.log(weightval);
        if ((day >= 1) && (day <= 26)) {
          rate = 810;
        }
        if (day > 26) {
          rate = 990;
        }
      }
      if (month === 'Dec') {
        if ((day >= 1) && (day <= 15)) {
          rate = 990;
        }
        if ((day > 15) && (day <= 31)) {
          rate = 1035;
        }
      }
      if (month === 'Jan') {
        rate = 846;
      }
      if (month === 'Feb') {
        rate = 846;
      }
    }
    if (routeval === 'INTERNATIONAL') {
      if (month === 'Nov') {
        console.log(routeval);
        console.log(month);
        console.log(weightval);
        if ((day >= 1) && (day <= 26)) {
          rate = 720;
        }
        if (day > 26) {
          rate = 880;
        }
      }
      if (month === 'Dec') {
        if ((day >= 1) && (day <= 15)) {
          rate = 880;
        }
        if ((day > 15) && (day <= 31)) {
          rate = 920;
        }
      }
      if (month === 'Jan') {
        rate = 752;
      }
      if (month === 'Feb') {
        rate = 752;
      }
    }
    if (rate > 0) {
      const feeforallval =  rate * weightval;
      setshowfees(true);
      setfee(feeforallval);
    }
    if (rate === 0) {
      setshowfees(false);
      setfee('----');
    }
    console.log(rate);
  }

  function calculateRateWeight(weight) {
    const date = startDate;
    const month = moment(date).format('MMM');
    const day = moment(date).format('D');
    let rate = 0;
    let routeval = route;
    const weightval = weight;
    if (weightval === 0) {
      routeval = 'NA';
    }
    if (routeval === 'BOTH') {
      if (month === 'Nov') {
        console.log(routeval);
        console.log(month);
        console.log(weightval);
        if ((day >= 1) && (day <= 26)) {
          rate = 360;
        }
        if (day > 26) {
          rate = 440;
        }
      }
      if (month === 'Dec') {
        if ((day >= 1) && (day <= 15)) {
          rate = 440;
        }
        if ((day > 15) && (day <= 31)) {
          rate = 460;
        }
      }
      if (month === 'Jan') {
        rate = 376;
      }
      if (month === 'Feb') {
        rate = 376;
      }
    }
    if (routeval === 'DOMESTIC') {
      if (month === 'Nov') {
        console.log(routeval);
        console.log(month);
        console.log(weightval);
        if ((day >= 1) && (day <= 26)) {
          rate = 810;
        }
        if (day > 26) {
          rate = 990;
        }
      }
      if (month === 'Dec') {
        if ((day >= 1) && (day <= 15)) {
          rate = 990;
        }
        if ((day > 15) && (day <= 31)) {
          rate = 1035;
        }
      }
      if (month === 'Jan') {
        rate = 846;
      }
      if (month === 'Feb') {
        rate = 846;
      }
    }
    if (routeval === 'INTERNATIONAL') {
      if (month === 'Nov') {
        console.log(routeval);
        console.log(month);
        console.log(weightval);
        if ((day >= 1) && (day <= 26)) {
          rate = 720;
        }
        if (day > 26) {
          rate = 880;
        }
      }
      if (month === 'Dec') {
        if ((day >= 1) && (day <= 15)) {
          rate = 880;
        }
        if ((day > 15) && (day <= 31)) {
          rate = 920;
        }
      }
      if (month === 'Jan') {
        rate = 752;
      }
      if (month === 'Feb') {
        rate = 752;
      }
    }
    if (rate > 0) {
      const feeforallval = rate * weightval;
      setshowfees(true);
      setfee(feeforallval);
    }
    if (rate === 0) {
      setshowfees(false);
      setfee('----');
    }
  }

  function calculateRateRoute(route) {
    const date = startDate;
    const month = moment(date).format('MMM');
    console.log(month);
    const day = moment(date).format('D');
    let rate = 0;
    let routeval = route;
    const weightval = weight;
    if (weightval === 0) {
      console.log('here');
      routeval = 'NA';
    }
    if (routeval === 'BOTH') {
      console.log('here1');
      if (month === 'Nov') {
        console.log(routeval);
        console.log(month);
        console.log(weightval);
        if ((day >= 1) && (day <= 26)) {
          rate = 360;
        }
        if (day > 26) {
          rate = 440;
        }
      }
      if (month === 'Dec') {
        if ((day >= 1) && (day <= 15)) {
          rate = 440;
        }
        if ((day > 15) && (day <= 31)) {
          rate = 460;
        }
      }
      if (month === 'Jan') {
        rate = 376;
      }
      if (month === 'Feb') {
        rate = 376;
      }
    }
    if (routeval === 'DOMESTIC') {
      console.log('here2');
      if (month === 'Nov') {
        console.log(routeval);
        console.log(month);
        console.log(weightval);
        if ((day >= 1) && (day <= 26)) {
          rate = 810;
        }
        if (day > 26) {
          rate = 990;
        }
      }
      if (month === 'Dec') {
        if ((day >= 1) && (day <= 15)) {
          rate = 990;
        }
        if ((day > 15) && (day <= 31)) {
          rate = 1035;
        }
      }
      if (month === 'Jan') {
        rate = 846;
      }
      if (month === 'Feb') {
        rate = 846;
      }
    }
    if (routeval === 'INTERNATIONAL') {
      console.log('here3');
      if (month === 'Nov') {
        console.log(routeval);
        console.log(month);
        console.log(weightval);
        if ((day >= 1) && (day <= 26)) {
          rate = 720;
        }
        if (day > 26) {
          rate = 880;
        }
      }
      if (month === 'Dec') {
        if ((day >= 1) && (day <= 15)) {
          rate = 880;
        }
        if ((day > 15) && (day <= 31)) {
          rate = 920;
        }
      }
      if (month === 'Jan') {
        rate = 752;
      }
      if (month === 'Feb') {
        rate = 752;
      }
    }
    console.log(rate);
    if (rate > 0) {
      const feeforallval = rate * weightval;
      setshowfees(true);
      setfee(feeforallval);
    }
    if (rate === 0) {
      setshowfees(false);
      setfee('----');
    }
    
  }

const transition = useTransition(on, null, {
from: { opacity: 0 },
enter: { opacity: 1 },
leave: { opacity: 0 }
});

function toggleModal() {
  setOpen(!isOpen);
}

function handleImageLoaded() {
  setLoad(true);
}

function submitCP() {
  const name = bname;
  const pername = person;
  const email = bemail;
  const number = bnum;
  console.log(name);

  const cp = {
    businessname : name,
    businessperson : pername,
    businessnum : number,
    businessemail : email,
    type: 'either'
  };

  database.ref('beckbagpartner').child(number).update(cp);

  setack(true);


}  

  return (
    <div className="App" style={{ background: 'white' }}>
    <Helmet>
        {/* <!-- HTML Meta Tags --> */}
        <title>BECK | BeckBags | BECKFriends.com</title>
        <meta
          name="description"
          content="Network of merchants and travel partners"
        />

        {/* <!-- Google / Search Engine Tags --> */}
        <meta itemprop="name" content="BeckBags | Travel Meets Logistics" />
        <meta
          itemprop="description"
          content="Economising travel fees and simplifying shipping"
        />
        <meta
          itemprop="image"
          content="https://firebasestorage.googleapis.com/v0/b/project-1348531828359008657.appspot.com/o/Travel%20for%20Business.png?alt=media&token=d1459dd1-db75-4d98-99a4-27a2cfff3f89"
        />

        {/* <!-- Facebook Meta Tags --> */}
        <meta property="og:url" content="https://beckbags.in" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="BeckBags | Travel Meets Logistics" />
        <meta
          property="og:description"
          content="Economising travel fees and simplifying shipping"
        />
        <meta
          property="og:image"
          content="https://firebasestorage.googleapis.com/v0/b/project-1348531828359008657.appspot.com/o/Travel%20for%20Business.png?alt=media&token=d1459dd1-db75-4d98-99a4-27a2cfff3f89"
        />

        {/* <!-- Twitter Meta Tags --> */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="BeckBags | Travel Meets Logistics" />
        <meta
          name="twitter:description"
          content="Economising travel fees and simplifying shipping"
        />
        <meta
          name="twitter:image"
          content="https://firebasestorage.googleapis.com/v0/b/project-1348531828359008657.appspot.com/o/Travel%20for%20Business.png?alt=media&token=d1459dd1-db75-4d98-99a4-27a2cfff3f89"
        />
      </Helmet>
      <section className="container-pic-beckbags-common newbeckbagback mobilehide">
        <div style={{ margin: '10px' }}>
        </div>
        <div className="row" style={{ marginTop: '1%', padding: '10px 1% 10px 1%', marginRight: '0px', marginLeft: '0px' }}>
          <div className="col-md-6 col-lg-5 shadowonesleft" style={{ }}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
              <img className="beckbaglogo" src={'https://firebasestorage.googleapis.com/v0/b/project-1348531828359008657.appspot.com/o/BECKFriends.com.png?alt=media&token=edf45c4f-ac6e-4e62-add0-d9580f34c9f8'} alt="profilePic" style={{ width: '50%', float: 'left' }} />
              </div>
            {!imageLoad && <svg width="200" height="200" viewBox="0 0 100 100" style={{ marginBottom: '10px' }}>  
            <rect width="100" height="100" rx="10" ry="10" fill="#ccc" />
          </svg>}
            <img className="beckbaglogo" onLoad={handleImageLoaded} src={'https://firebasestorage.googleapis.com/v0/b/project-1348531828359008657.appspot.com/o/beckfriends.png?alt=media&token=3d94bfe5-092f-400b-9bfe-d24df817dd5d'} alt="Peer to Peer Delivery" style={{ width: '87%', marginTop: '10px', marginLeft: '5px' }} />
            <h1 className="mobiletext" style={{ fontSize: '20px', textAlign: 'center', marginLeft: '15px', color: 'black' }}>BECKFriends is a peer to peer shipping service that allows travelers to earn by monetising luggage space and is a inexpensive shipping channel for merchants</h1>
            <a target="_blank" href="https://www.beckfriends.com"><button className="btn btn-primary inlineblock buybtn_1 buybtn_2" style={{ backgroundColor: 'white', color: 'red', border: '1px solid red', outline: 'none', letterSpacing: 2, fontWeight: 600, borderRadius: '5px', textTransform: 'uppercase', marginLeft: '15px', padding: '1em', fontSize: '1.2em', marginTop: '20px', fontWeight: '600' }}>Take Me There</button></a>
          </div>
          <div className="col-md-6 col-lg-5 shadowonesright" style={{ float: 'right' }}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
              <img className="beckbaglogo" src={'https://firebasestorage.googleapis.com/v0/b/beckfriends-2-a4131.appspot.com/o/beckbag_logo_solid_modified_small.png?alt=media&token=fa4e1225-d665-484f-9db1-ac6f369da512'} alt="profilePic" style={{ float: 'left' }} />
              </div>
            {!imageLoad && <svg width="200" height="200" viewBox="0 0 100 100" style={{ marginBottom: '10px' }}>  
            <rect width="100" height="100" rx="10" ry="10" fill="#CCC" />
          </svg>}
            <img className="beckbaglogo" onLoad={handleImageLoaded} src={'https://firebasestorage.googleapis.com/v0/b/project-1348531828359008657.appspot.com/o/beckbags.jpg?alt=media&token=22f92204-77b4-4f02-872a-9ef047d5211f'} alt="BeckBags" style={{ width: '90%', marginTop: '10px', marginLeft: '5px' }} />
            <h1 className="mobiletext" style={{ fontSize: '20px', textAlign: 'center', marginLeft: '15px', color: 'black' }}>BECKBags is a SAAS product that integrates with the your booking interface and allows you to increase your ancillary revenue by monetising the unused luggage space</h1>
            <a target="_blank" href="https://www.beckbags.in"><button className="btn btn-primary inlineblock buybtn_1 buybtn_2" style={{ backgroundColor: 'white', color: 'red', border: '1px solid red', outline: 'none', letterSpacing: 2, fontWeight: 600, borderRadius: '5px', textTransform: 'uppercase', marginLeft: '15px', padding: '1em', fontSize: '1.2em', marginTop: '20px', fontWeight: '600' }}>Take Me There</button></a>
          </div>
        </div>
        <div className="row" style={{ marginTop: '1%', padding: '10px 1% 10px 1%', marginRight: '0px', marginLeft: '0px' }}>
          <h1 className="mobiletext" style={{ textAlign: 'center', color: 'black', fontWeight: '600' }}>In Media</h1>
          <div style={{ padding: '1em', paddingBottom: '1.5em' }}>
       { mobile ? 
       <div style={{ width: width-40, overflowX: 'scroll', display: 'flex', alignItems: 'center' }} >
          {tileData.map((tile) => (
            <Link to={{ pathname: tile.link }} target="_blank"><img src={tile.img} alt={tile.title} style={{ marginLeft: '1rem', marginRight: '1em', width: '200px' }}/></Link>
        ))}
       </div> : <div style={{ width: width-40, overflowX: 'scroll', display: 'flex', alignItems: 'center' }} >
          {tileData.map((tile) => (
             <Link to={{ pathname: tile.link }} target="_blank"><img src={tile.img} alt={tile.title} style={{ marginLeft: '1rem', marginRight: '1em', width: '200px' }}/></Link>
        ))}
       </div>}
       </div>
        </div>
      </section>
      <ReactModal
           className="ModalReq"
           isOpen={isOpen}
           contentLabel="Modal #1 Global Style Override Example"
           onRequestClose={toggleModal}
        >
          { !ack && <h4 className="headertext2 header3" style={{ width: '100%', fontWeight: 800, color: '#000', marginBottom: '2em', fontSize: '1.4em', textAlign: 'center' }}>Please share your details here</h4>}
          <button onClick={toggleModal} style={{ position: 'absolute', top: '10px', right: '10px', border: '0px', background: 'white' }}>❌</button>
          { !ack && <input className="another buydiv mobilepartner" type="text" placeholder="Business Name" value={bname} onChange={setbname} onChange={event => setbname(event.target.value)} style={{ width: '100%', border: '1px solid Black', borderWidth: '0px', background: '#ffffff', fontWeight: 600, marginBottom: '1em', borderBottomWidth: '1px' }} />}
              { !ack && <input className="another buydiv mobilepartner" type="text" placeholder="Contact Person" value={person} onChange={event => setperson(event.target.value)} style={{ width: '100%', border: '1px solid Black', borderWidth: '0px', background: '#ffffff', fontWeight: 600, marginBottom: '1em', borderBottomWidth: '1px' }} />}
              { !ack && <input className="another buydiv mobilepartner" type="text" placeholder="Contact Email" value={bemail} onChange={event => setemail(event.target.value)} style={{ width: '100%', border: '1px solid Black', borderWidth: '0px', background: '#ffffff', fontWeight: 600, marginBottom: '1em', borderBottomWidth: '1px' }} />}
              { !ack && <input className="another buydiv mobilepartner" type="text" placeholder="Contact Number" value={bnum} onChange={event => setnum(event.target.value)} style={{ width: '100%', border: '1px solid Black', borderWidth: '0px', background: '#ffffff', fontWeight: 600, marginBottom: '1em', borderBottomWidth: '1px' }} />}
              { !ack && <button onClick={submitCP} className="btn btn-primary inlineblock buybtn_1 buybtn_2  mobilepartner" style={{ backgroundColor: '#2bb1de', border: 'none', outline: 'none', letterSpacing: 1, fontWeight: 600, width: '85%', borderRadius: '5px', textTransform: 'uppercase', width: '100%', marginTop: '15px' }}>Submit</button>}
              { ack && <h4 className="headertext2 header3" style={{ width: '100%', fontWeight: 800, color: 'green', marginBottom: '1em', fontSize: '1.4em', textAlign: 'center' }}>Submitted Successfully ✅</h4>}
              { ack && <h4 className="headertext2 header3" style={{ width: '100%', fontWeight: 800, color: 'green', fontSize: '1.4em', textAlign: 'center' }}>Our team will be in touch shortly</h4>}
        </ReactModal>
      <section className="container-pic-beckbags-common newbeckbagback desktophide">
        <div style={{ margin: '10px' }}>
        </div>
        <div className="row" style={{ marginTop: '1%', marginRight: '0px', marginLeft: '0px' }}>
          <div className="col-md-6">
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
              <img className="" src={'https://firebasestorage.googleapis.com/v0/b/project-1348531828359008657.appspot.com/o/BECKFriends.com.png?alt=media&token=edf45c4f-ac6e-4e62-add0-d9580f34c9f8'} alt="profilePic" style={{ width: '80%', float: 'left' }} />
            </div>
            {!imageLoad && <svg width="200" height="200" viewBox="0 0 100 100" style={{ marginBottom: '10px' }}>  
            <rect width="100" height="100" rx="10" ry="10" fill="#ccc" />
            </svg>}
            <img className="" onLoad={handleImageLoaded} src={'https://firebasestorage.googleapis.com/v0/b/project-1348531828359008657.appspot.com/o/beckfriends.png?alt=media&token=3d94bfe5-092f-400b-9bfe-d24df817dd5d'} alt="BECFKriends" style={{ width: '100%', marginTop: '10px' }} />
            <h1 className="" style={{ fontSize: '20px', textAlign: 'center', color: 'black' }}>BECKFriends is a peer to peer shipping service that allows travelers to earn by monetising luggage space and is a inexpensive shipping channel for merchants</h1>
            <a target="_blank" href="https://www.beckfriends.com"><button className="btn btn-primary inlineblock buybtn_1 buybtn_2" style={{ backgroundColor: 'white', color: 'red', border: '1px solid red', outline: 'none', letterSpacing: 2, fontWeight: 600, borderRadius: '5px', textTransform: 'uppercase', marginLeft: '15px', padding: '1em', fontSize: '1.2em', marginTop: '20px', fontWeight: '600' }}>Take Me There</button></a>
          </div>
          <div className="col-md-6" style={{ marginTop: '2em' }}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', marginTop: '1.5em' }}>
              <img className="" src={'https://firebasestorage.googleapis.com/v0/b/beckfriends-2-a4131.appspot.com/o/beckbag_logo_solid_modified_small.png?alt=media&token=fa4e1225-d665-484f-9db1-ac6f369da512'} alt="profilePic" style={{ float: 'left' }} />
            </div>
            {!imageLoad && <svg width="200" height="200" viewBox="0 0 100 100" style={{ marginBottom: '10px' }}>  
            <rect width="100" height="100" rx="10" ry="10" fill="#ccc" />
            </svg>}
            <img className="" onLoad={handleImageLoaded}src={'https://firebasestorage.googleapis.com/v0/b/project-1348531828359008657.appspot.com/o/beckbags.jpg?alt=media&token=22f92204-77b4-4f02-872a-9ef047d5211f'} alt="BeckBags" style={{ width: '100%', marginTop: '10px' }} />
            <h1 className="" style={{ fontSize: '20px', textAlign: 'center', color: 'black' }}>BECKBags is a SAAS product that integrates with the your booking interface and allows you to increase your ancillary revenue by monetising the unused luggage space</h1>
            <a target="_blank" href="https://www.beckbags.in"><button onClick={toggleModal} className="btn btn-primary inlineblock buybtn_1 buybtn_2" style={{ marginBottom: '10px', backgroundColor: '#fff', color: 'red', border: '1px solid red', outline: 'none', letterSpacing: 2, fontWeight: 600, borderRadius: '5px', textTransform: 'uppercase', marginLeft: '15px', padding: '1em', fontSize: '1.2em', marginTop: '20px', fontWeight: '600' }}>Take Me There</button></a>
          </div>
        </div>
        <div className="row" style={{ marginTop: '1%', padding: '10px 1% 10px 1%', marginRight: '0px', marginLeft: '0px' }}>
          <h1 className="mobiletext" style={{ textAlign: 'center', color: 'black', fontWeight: '600' }}>In Media</h1>
          <div style={{ padding: '1em', paddingBottom: '1.5em' }}>
       { mobile ? 
       <div style={{ width: width-40, overflowX: 'scroll', display: 'flex', alignItems: 'center' }} >
          {tileData.map((tile) => (
            <Link to={{ pathname: tile.link }} target="_blank"><img src={tile.img} alt={tile.title} style={{ marginLeft: '1rem', marginRight: '1em', width: '200px' }}/></Link>
        ))}
       </div> : <div style={{ width: width-40, overflowX: 'scroll', display: 'flex', alignItems: 'center' }} >
          {tileData.map((tile) => (
             <Link to={{ pathname: tile.link }} target="_blank"><img src={tile.img} alt={tile.title} style={{ marginLeft: '1rem', marginRight: '1em', width: '200px' }}/></Link>
        ))}
       </div>}
       </div>
        </div>
      </section>
             
    </div>

  );
}

export default App;
